<template>
    <div class="col-12 mt-1">
        <div class="card">
            <div class="card-body my-0 mx-0">
                <div class="row">
                    <div class="col-12">
                        <h4>Lista de Notificaciones
                            <el-tooltip effect="dark"
                                placement="top"
                            >
                                <div slot="content">
                                    <strong>- Editar:</strong> al editar la notificación, la notificación original enviada no se cambiará, tendrás que enviar de nuevo la notificación editada, para que se envíe el nuevo cambio.<br/>
                                    <strong>- Eliminar o inhabilitar:</strong> las notificaciones enviadas serán inhabilitadas<br/>
                                    Si eliminas o inhabilitadas, serán enviadas a segun plano (colas)
                                </div>
                                <i class="fa fa-info-circle"></i>
                            </el-tooltip>
                        </h4>
                    </div>
                    <div class="col-12" v-for="notification in notifications">
                        <div class="card mb-2">
                            <div class="card-body"
                                :class="{ 'notification_disabled' : !notification.active }"
                            >
                                <div class="row">
                                    <div class="col-12 col-lg-10">
                                        <h5>Nombre: {{ notification.title }}</h5>
                                        <p>Descripción: {{ notification.message }}</p>
                                    </div>
                                    <div class="col-12 col-lg-2 text-right">
                                        <div class="d-flex" style="gap: 2px; justify-content: flex-end;">
                                            <el-button
                                                circle
                                                plain
                                                type="info"
                                                size="small"
                                                @click.prevent="$emit('edit-notification', notification.id)"
                                            >
                                                <i class="fa fa-edit"></i>
                                            </el-button>
                                            <el-button
                                                circle
                                                plain
                                                size="small"
                                                @click.prevent="$emit('disable-notification', notification.id, notification.active)"
                                            >
                                                <template v-if="notification.active">
                                                    <i class="fa fa-times text-danger"></i>
                                                </template>
                                                <template v-else>
                                                    <i class="fa fa-check text-success"></i>
                                                </template>
                                            </el-button>
                                            <el-button
                                                circle
                                                plain
                                                type="danger"
                                                size="small"
                                                @click.prevent="$emit('delete-notification', notification.id)"
                                            >
                                                <i class="fa fa-trash"></i>
                                            </el-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 text-center">
                        <el-pagination
                            :total="pagination.total"
                            :current-page="pagination.current_page"
                            :page-size="pagination.per_page"
                            @current-change="page => $emit('page-change', page)"
                            layout="total, prev, pager, next"></el-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ListNotification',

        props: {
            notifications: {
                type: Array,
                default: () => []
            },
            pagination: {
                type: Object,
                default: () => ({})
            }
        }
    }
</script>

<style>
    .notification_disabled {
        border: 1px solid #ec2a2a !important;
    }
</style>


// WEBPACK FOOTER //
// resources/js/views/system/notifications/partials/ListNotification.vue